export const API_ERROR = "api_failed";

export const RFQ_LIST = "cq_rfq_list";
export const RFQ_LIST_SUCCESS = "cq_rfq_list_success";

export const SELECT_CHANGEVALUE = "cQ_Select_ChangeValue";

export const RFQ_ROW_DATA = "CQ_rfq_row_data";
export const RFQ_ROW_DATA_SUCCESS = "CQ_rfq_row_data_success";

export const QUOTATION_ROW_DATA = "Compare_Quotation_row_data";
export const QUOTATION_ROW_DATA_SUCCESS = "Compare_Quotation_row_data_success";

export const QUOTATION_CHECKED = "CQ_Quotation_Checked";
export const APPROVED_QUANTITY = "CQ_ApprovedQuantity";
export const RESET_CELL_UPDATE = "CQ_reset_cell_Update";

export const COMPARE_QUOTATION_ADD = "Compare_Quotation_Add";

export const COMPARE_QOUTATION_DATA = "Compare_Quotation_data";
export const COMPARE_QOUTATION_DATA_SUCCESS = "Compare_Quotation_data_success";

export const COMPARE_QOUTATION_LIST = "Compare_Quotation_list";
export const COMPARE_QOUTATION_LIST_SUCCESS = "Compare_Quotation_list_success";

export const SET_PARAMS = "CQ_set_params";
export const FILTER_INPUT_CHANGEVALUE = "CQ_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "CQ_Filter_Select_ChangeValue";

export const TOGGLE_ITEM_MENU = "CQ_toggle_item_menu";

export const PURCHASE_ORDER_DATA = "Purchase_Order_Data";

export const PURCHASE_ORDER_LIST = "CQ_Purchase_Order_list";
export const PURCHASE_ORDER_LIST_SUCCESS = "CQ_Purchase_Order_list_Success";
export const GENERATE_PURCHASE_ORDER = "Generate_Purchase_Order";
export const GENERATE_PURCHASE_ORDER_RESPONSE =
  "Generate_Purchase_Order_response";
export const LIST_LAYOUT = "CQ_list_layout";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "CQ_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "CQ_filter_hide_right_sidebar";
export const CLEAR_FILTER = "CQ_clear_filter";

export const PO_MODEL_CLOSE = "CQ_PO_model_close_1";
export const PO_MODEL_OPEN = "CQ_PO_model_open";

export const PO_VEND_DATA = "CQ_po_vend_data";
export const INPUT_CHANGEVALUE = "CQ_input_ChangeValue";
export const RESET_SUBLOCATION = 'RESET_SUBLOCATION';
export const PO_SELECT_CHANGEVALUE = "CQ_PO_Select_ChangeValue";

